/* eslint no-barrel-files/no-barrel-files: off -- Alloy's synchronous dynamic transform requires direct named exports from this shared chunk. */
import {CommitEntrypointFuture, CommitPathEntrypointFuture} from './Commit'
import {CommitsEntrypointFuture, CommitsRefEntrypointFuture} from './Commits'
import {CommitsLayout} from './CommitsLayout'
import type {CommitsRouteComponents} from './create-commits-routes'

export {
  CommitEntrypointFuture,
  CommitPathEntrypointFuture,
  CommitsEntrypointFuture,
  CommitsLayout,
  CommitsRefEntrypointFuture,
}

export const commitsRouteComponents = {
  CommitsLayout,
  CommitsEntrypointFuture,
  CommitsRefEntrypointFuture,
  CommitEntrypointFuture,
  CommitPathEntrypointFuture,
} satisfies CommitsRouteComponents
